<template>
  <v-app id="inspire" class="d-flex">
    <v-btn
      v-if="isMobileOrTablet()"
      id="draggable-btn"
      class="mx-2"
      fab
      dark
      small
      color="primary"
    >
      <v-icon dark>{{
        isClicked ? 'mdi-cursor-move' : 'mdi-cursor-pointer'
      }}</v-icon>
    </v-btn>
    <v-navigation-drawer
      v-if="expandDrawer"
      app
      absolute
      permanent
      :touchless="true"
    >
      <deduction-drawer></deduction-drawer>
    </v-navigation-drawer>
    <working-board
      v-if="elective"
      :key="elective && `${elective.id}${elective.rpt_status}`"
    ></working-board>
    <v-navigation-drawer
      v-model="showWorkingDrawer"
      app
      absolute
      right
      :stateless="expandDrawer"
      :temporary="!expandDrawer"
      width="270"
    >
      <working-drawer></working-drawer>
    </v-navigation-drawer>

    <!-- 选择需要批阅的场次 -->
    <v-navigation-drawer
      v-model="showTodoDrawer"
      right
      app
      temporary
      width="400"
    >
      <todo-drawer></todo-drawer>
    </v-navigation-drawer>
    <v-dialog v-model="confirmShow" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text class="font-weight-black">{{
          confirmMessage
        }}</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="green darken-1"
            text
            :disabled="pendingConfirm"
            @click="close"
            >取消</v-btn
          >
          <v-btn
            color="primary"
            :disabled="pendingConfirm"
            @click="confirmAction"
          >
            确认
            <v-progress-circular
              v-if="pendingConfirm"
              indeterminate
              color="red"
              size="20"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <change-password></change-password>
    <deduction-dialog></deduction-dialog>
    <deduction-type-dialog></deduction-type-dialog>
    <sendback-dialog></sendback-dialog>
    <v-snackbar v-model="alert" :color="alertColor" top class="title">{{
      alertMessage
    }}</v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import DeductionDrawer from '../components/DeductionDrawer';
import WorkingBoard from '../components/WorkingBoard';
import WorkingDrawer from '../components/WorkingDrawer';
import TodoDrawer from '../components/TodoDrawer';
import DeductionDialog from '../components/DeductionDialog';
import DeductionTypeDialog from '../components/DeductionTypeDialog';
import SendbackDialog from '../components/SendbackDialog';
import ChangePassword from '../components/ChangePassword';

export default {
  data() {
    return {
      canClick: true,
      isClicked: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      moveThreshold: 15
    };
  },
  computed: {
    ...mapGetters([
      'elective',
      'workingDrawer',
      'todoDrawer',
      'userDrawer',
      'alert',
      'alertColor',
      'alertMessage',
      'confirmShow',
      'confirmMessage',
      'confirmAction',
      'pendingConfirm',
      'curCanvasIndex'
    ]),
    expandDrawer: () => {
      return true; //window.innerWidth >= 1440;
    },
    showWorkingDrawer: {
      get() {
        return this.workingDrawer;
      },
      set(value) {
        this.$store.commit('toggleWorkingDrawer', value);
      }
    },
    showTodoDrawer: {
      get() {
        return this.todoDrawer;
      },
      set(value) {
        this.$store.commit('toggleTodoDrawer', value);
      }
    }
  },
  mounted() {
    if (this.isMobileOrTablet()) {
      const btn = document.getElementById('draggable-btn');
      btn.addEventListener('touchstart', this.touchstartHandler);
    }
  },
  components: {
    DeductionDrawer,
    WorkingBoard,
    WorkingDrawer,
    TodoDrawer,
    DeductionDialog,
    DeductionTypeDialog,
    SendbackDialog,
    ChangePassword
  },
  methods: {
    isMobileOrTablet() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    touchstartHandler(e) {
      this.canClick = true;
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;

      const btn = document.getElementById('draggable-btn');
      const rect = btn.getBoundingClientRect();
      this.offsetX = this.startX - rect.left;
      this.offsetY = this.startY - rect.top;

      document.addEventListener('touchmove', this.touchmoveHandler, {
        passive: false
      });
      document.addEventListener('touchend', this.touchendHandler);
    },
    touchmoveHandler(e) {
      e.preventDefault();

      const { clientX, clientY } = e.touches[0];
      const dx = Math.abs(clientX - this.startX);
      const dy = Math.abs(clientY - this.startY);

      if (dx > this.moveThreshold || dy > this.moveThreshold) {
        const btn = document.getElementById('draggable-btn');
        btn.classList.add('is-dragging');

        this.canClick = false;
        this.dragBtn(clientX, clientY);
      }
    },
    touchendHandler() {
      if (this.canClick) {
        this.clickBtn();
      } else {
        const btn = document.getElementById('draggable-btn');
        btn.classList.toggle('is-dragging');
      }

      document.removeEventListener('touchmove', this.touchmoveHandler);
      document.removeEventListener('touchend', this.touchendHandler);
    },
    dragBtn(clientX, clientY) {
      const btn = document.getElementById('draggable-btn');
      btn.style.left = `${Math.max(
        0,
        Math.min(innerWidth - btn.offsetWidth, clientX - this.offsetX)
      )}px`;
      btn.style.top = `${Math.max(
        0,
        Math.min(innerHeight - btn.offsetHeight, clientY - this.offsetY)
      )}px`;
    },
    clickBtn() {
      this.isClicked = !this.isClicked;

      const canvas = document.querySelector(
        `canvas#canvas-${this.curCanvasIndex}`
      );
      const nextCanvas = canvas.nextElementSibling;

      if (!canvas.style.pointerEvents) {
        canvas.style.pointerEvents = 'none';
      } else {
        canvas.style.pointerEvents = '';
      }

      if (!nextCanvas.style.pointerEvents) {
        nextCanvas.style.pointerEvents = 'none';
      } else {
        nextCanvas.style.pointerEvents = '';
      }
    },
    close() {
      this.$store.commit('setConfirm', '');
    }
  }
};
</script>
<style scoped>
#draggable-btn {
  position: absolute;
  right: 0;
  bottom: 1%;
  z-index: 999;
  transition: transform 0.25s ease-out;
}
.is-dragging {
  transform: scale(1.5);
}
</style>
